module.exports = __webpack_public_path__ + "img/yzt.df102183.jpg";